import React from 'react';
import ReactImageGalery from 'react-image-gallery';

const ImageGallery = ({ imageGalleryRef, ...props }) => (
  <ReactImageGalery
    additionalClass="image-gallery"
    useTranslate3D={false}
    showPlayButton={false}
    ref={imageGalleryRef}
    // renderThumbInner={(...args) => {
    //   console.log('render thumb inner', ...args);
    //   return <div />;
    // }}
    {...props}
  />
);

export default ImageGallery;
